import React from "react";

import {
  withTheme,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  withStyles,
  Button,
  CircularProgress
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
// import Swipe from 'react-easy-swipe'
import s from "./feedback.module.css";
// import { theme } from '../../framework/theme'
import GlobalContext from "../../context/globalContext";
import PropTypes from "prop-types";
import { styles } from "./style";
import qs from "querystring";
class Feedback extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      confirmationText: null,
      ableToSubmit: false,
      orderUuid: null
    };
  }

  componentDidMount() {
    let q = qs.parse(this.props.location.search.replace("?", ""));
    this.setState({ orderUuid: q.orderUuid });
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
      ableToSubmit: true
    });
  };

  render() {
    const { message, orderUuid } = this.state;
    const { classes } = this.props;
    const { postFeedback, openSuccessSnackbar } = this.context.global;

    return (
      <>
        <AppBar className={s.accountAppBar}>
          <Toolbar className={s.accountToolbar}>
            <div className={s.accountAppBarContentContainer}>
              <div className={s.accountAddressContainer}>
                <Typography variant="body1" style={{ color: "white" }}>
                  Feedback
                </Typography>
              </div>
            </div>
            <div className={s.accountCloseButtonContainer}>
              <IconButton
                color="inherit"
                onClick={() => {
                  this.props.history.replace("/dashboard");
                }}
                aria-label="Close"
                className={s.accountAppBar}
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.content}>
          <p style={{ fontWeight: 800, fontSize: 17 }}>
            We'd love to hear from you.
          </p>
          <div style={{ fontSize: "smaller" }}>
            Didn't see something you want? Have a problem with the app? Just
            want to say hi? Drop us a line!
          </div>
          <div style={{ height: 40 }} />

          <textarea
            name="message"
            onChange={this.handleChange}
            style={{
              padding: 10,
              fontSize: 14,
              fontFamily: "Arial",
              height: 200
            }}
          />

          <div style={{ height: 40 }} />
          <div>{this.state.confirmationText}</div>
          <Button
            disabled={!this.state.ableToSubmit}
            onClick={async () => {
              this.setState({ submitting: true, ableToSubmit: false });
              await postFeedback({
                message,
                orderUuid
              });
              this.setState({ submitting: false });
              openSuccessSnackbar("Thanks!");
              setTimeout(() => this.props.history.replace("/dashboard"), 1000);
            }}
          >
            {!this.state.submitting ? (
              `Let us know!`
            ) : (
              <CircularProgress style={{ height: 25, width: 25 }} />
            )}
          </Button>
        </div>
      </>
    );
  }
}

Feedback.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withTheme()(withStyles(styles)(Feedback));
